import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import case1 from "./components/case-1";
import case2 from "./components/case-2";
import case3 from "./components/case-3";
import case4 from "./components/case-4";

const principle: Slide = {
  description:
    "Add absorption in the source room and/or the receiving room and observe what happens with the sound pressure levels in both rooms (and the sound level difference D between both rooms). The sound source and the separating wall remain the same in all cases.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "dropdown",
          options: {},
          items: [
            { name: "Case 1: no added absorption" },
            { name: "Case 2: added absorption in source room" },
            { name: "Case 3: added absorption in receiving room" },
            { name: "Case 4: added absorption in both rooms" },
          ],
        },
      ],
      controlsPosition: "bottom",
      extraContent: [[], [], [], []],
      components: [case1, case2, case3, case4],
    },
  },
};

export default principle;
